import React, { useState } from "react";
import "./header.scss";
import { HeaderView } from "./header-view";

export const HeaderControler = (props) => {
	const [dropdownIndex, setDropdownIndex] = useState(null);
	
	const HandleDropdown = (ddlIndex) => {
		if (ddlIndex === dropdownIndex) {
			setDropdownIndex(null);
		} else {
			setDropdownIndex(ddlIndex);
		}
	};
	
	return <HeaderView dropdownIndex={dropdownIndex}  HandleDropdown={HandleDropdown} userShortname="SC" {...props} />;
};
